import React, { Component } from "react";
import { connect } from "react-redux";

import { Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import { productItemHistoryModelClose } from "../../store/MaterialRequest/actions";
import moment from "moment";

class ProductItemHistoryLog extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.productItemHistory_model}
          backdrop="static"
          centered
          size="xl"
        >
          <ModalHeader toggle={() => this.props.productItemHistoryModelClose()}>
            Product Item History
          </ModalHeader>

          <ModalBody>
            <div
              className="table-responsive m-0"
              style={{
                maxHeight: "550px",
                overflowY: "auto",
              }}
            >
              <Table
                // striped
                bordered
                hover
                responsive
                className="mb-0 p-0 table-centered"
              >
                <thead className="bg-light text-center">
                  <tr>
                    <th className="nowrap">S.No</th>
                    <th className="nowrap">Item Name</th>
                    <th className="nowrap">
                      From
                      <br />
                      (Qty / Units)
                    </th>
                    <th className="nowrap">
                      To
                      <br />
                      (Qty / Units)
                    </th>
                    <th className="nowrap">Status</th>
                    <th className="nowrap">Approved Date</th>
                    <th className="nowrap">Approved By</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.productItemLoglist.length === 0 ? (
                    <>
                      <tr>
                        <td colspan="5" className="text-center">
                          <span className="font-size-18 text-danger">
                            Data not available
                          </span>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      {this.props.productItemLoglist.map((Item, key) => (
                        <tr key={key}>
                          <td className="text-center">{key + 1}</td>
                          <td className="text-center">
                            {Item.t_product.name}
                            {(Item.mrstatus === 9 ||
                              Item.mrstatus === 10 ||
                              Item.mrstatus === 11) && (
                              <>
                                <br />
                                <spam className="font-size-12 text-danger">
                                  ( <del>{Item.f_product.name}</del> )
                                </spam>{" "}
                              </>
                            )}
                          </td>
                          <td className="text-center">
                            {Item.f_originalqty} {Item?.f_unit.name}
                          </td>
                          <td className="text-center">
                            {Item.t_originalqty} {Item?.t_unit.name}
                          </td>

                          <td className="text-center">{Item.mrstatus_name}</td>
                          <td className="text-center">
                            {moment(Item.createdon).format("DD-MM-YYYY")}
                          </td>
                          <td className="text-center">
                            {Item.approvedby.fullname} <br />(
                            {Item.approvedby.username})
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </Table>
            </div>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { productItemHistory_model, productItemLoglist } =
    state.Materialrequest;
  return {
    productItemHistory_model,
    productItemLoglist,
  };
};

export default connect(mapStatetoProps, {
  productItemHistoryModelClose,
})(ProductItemHistoryLog);
